import GameService from '~/services/game.service';
import { gameSelectors } from '~/store/selectors';
// ---- internal imports ----

import * as types from './actionTypes';
// ---- local imports ----


export function load(playerHealth) {
	return { type: types.PLAYER_HEALTH_LOADED, playerHealth };
}

export function update(newPlayerHealth, save = false) {
	return async (dispatch, getState) => {
		if (save) {
			const gameUserId = gameSelectors.getGameId(getState());
			await GameService.savePlayerHealth(gameUserId, newPlayerHealth);
		}

		dispatch({ type: types.PLAYER_HEALTH_UPDATED, playerHealth: newPlayerHealth });
	};
}

export function uiHandledLatestChange() {
	return { type: types.PLAYER_HEALTH_UI_HANDLED_LATEST_CHANGE };
}
